import { render, staticRenderFns } from "./DeleteAudios.vue?vue&type=template&id=82ff63be&scoped=true"
import script from "./DeleteAudios.vue?vue&type=script&lang=js"
export * from "./DeleteAudios.vue?vue&type=script&lang=js"
import style0 from "./DeleteAudios.vue?vue&type=style&index=0&id=82ff63be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ff63be",
  null
  
)

export default component.exports